'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _executivesummary = require('./executivesummary.component');

var _executivesummary2 = _interopRequireDefault(_executivesummary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var executivesummaryModule = _angular2.default.module('executivesummary', [_angularUiRouter2.default]).component('executivesummary', _executivesummary2.default);

exports.default = executivesummaryModule;


// WEBPACK FOOTER //
// ./client/app/common/reports/executivesummary/executivesummary.js